import { Component } from '@angular/core';
import { InformationCard } from '../../shared/models/card.type';
import { infoCards } from './new-user';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss'],
})
export class NewUserComponent {
  cards: InformationCard[] = infoCards;

  currentRoute = '/new-user';

  constructor(private analyticsService: AnalyticsService) {}

  scrollTop(): void {
    this.analyticsService.pushEvent('join_now', {
      category: 'Button Click',
      action: 'Scroll',
      element: 'New User CTA Join Now',
    });

    window.scrollTo(0, 0);
  }
}
